import { template } from "@ember/template-compiler";
export default template(`
  <div
    class="cost-estimator-footer__estimate-icon"
    data-test-cost-estimator-footer-icon
  >
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvYmlsbGluZy1jb21tb24vcGFja2FnZS9zcmMvY29tcG9uZW50cy9iaWxsaW5nL2Nvc3QtZXN0aW1hdG9yL2ljb24uZ2pzIl0sInNvdXJjZXNDb250ZW50IjpbIjx0ZW1wbGF0ZT5cbiAgPGRpdlxuICAgIGNsYXNzPVwiY29zdC1lc3RpbWF0b3ItZm9vdGVyX19lc3RpbWF0ZS1pY29uXCJcbiAgICBkYXRhLXRlc3QtY29zdC1lc3RpbWF0b3ItZm9vdGVyLWljb25cbiAgPlxuICAgIHt7eWllbGR9fVxuICA8L2Rpdj5cbjwvdGVtcGxhdGU-XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGVBQUEsU0FBVSxDQUFBOzs7Ozs7O0FBT1YsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBLEdBQUMifQ